import numbro from 'numbro';

export function formatCurrency(amount: number) {
  return numbro(amount).format({ thousandSeparated: true, mantissa: 0 });
}

export function formatPercent(amount: number) {
  return numbro(amount).format({ thousandSeparated: true, mantissa: 1, trimMantissa: true });
}
